import React from 'react';
import ProfileExperienceReview from './common/experience-review';

const PeerAudioReview: React.FunctionComponent = (): JSX.Element => {
  return <ProfileExperienceReview experienceType="audio" />;
};

export default PeerAudioReview;
